import React, { FC } from 'react';
import styled from 'styled-components/macro';

import { ColorVariants } from 'theme';

import pictorials from './pictorials';

export const Pictorials = pictorials;

const Wrapper = styled.div<{
    $color: ColorVariants;
}>`
    .Svg_sc {
        width: 76px;
        fill: ${({ theme, $color }) => theme.colors[$color]};

        .Stroke_sc {
            fill: none;
            stroke: ${({ theme, $color }) => theme.colors[$color]};
        }
    }
`;

export type PictorialProps = {
    icon: FC<React.SVGAttributes<SVGElement>>;
    color: ColorVariants;
} & React.HTMLAttributes<HTMLDivElement>;

const Pictorial: FC<PictorialProps> = ({ icon: Icon, color, ...rest }) => {
    return (
        <Wrapper $color={color} {...rest}>
            <Icon className="Svg_sc" />
        </Wrapper>
    );
};

export default Pictorial;
